import { toast } from "react-toastify";
import { HTTPURL } from "../../constants/Matcher";

const base = `${HTTPURL}api/branches`;

const toQs = (params) => {
  const clean = Object.fromEntries(
    Object.entries(params || {}).filter(
      ([, v]) => v !== undefined && v !== null && v !== ""
    )
  );
  return new URLSearchParams(clean).toString();
};

// Fetch a short-lived signed URL the browser can navigate to in order to
// land on tstm's Report Centre already authenticated.
export async function tstm_sso_link(params) {
  try {
    const qs = toQs(params);
    const res = await fetch(`${base}/tstm-sso-link${qs ? `?${qs}` : ""}`);
    const data = await res.json();
    if (!data?.status) toast.error(data?.message || "Failed to open Report Centre");
    return data;
  } catch (e) {
    toast.error(e.message);
    return { status: false, message: e.message };
  }
}
